module.exports = __webpack_public_path__ + "img/pharmacy.e9a681fc.svg";